/** Proveedor Zoom — clase en vivo por enlace externo validado (https). */
import { makeExternalProvider } from "./external";

export const zoomProvider = makeExternalProvider({
  id: "zoom",
  name: "Zoom",
  description: "Clase en vivo por enlace externo de Zoom (https validado).",
  requiresCredentials: false,
  urlPlaceholder: "https://zoom.us/j/…",
});
